import { HeaderService } from "@app/components/header/header.service";
import { SpinnerService } from "@app/services/spinner.service";
import { ContactApi } from "@app/services/apiServices/ContactApi";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { PMC } from "@app/models/PMC";
import { Phone } from "@app/models/Phone";
import { Url } from "@app/models/Url";
import { UserStore } from "@app/services/stores/UserStore";
import { HomeownerApi } from "@app/services/apiServices/HomeownerApi";
import { take } from "rxjs/operators";
import { Component, Inject, OnInit } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { CommonService } from "@app/services/CommonService";

@Component({
    selector: 'app-contact',
    template: require('./contact.html')
})
export class ContactComponent implements OnInit{

    pmc = {} as PMC;
    showPmcInfo: boolean = false;
    doneLoading: boolean;
    displayUrl: string;
    displayPhoneNumber: string;
    $stateParams: any;

    constructor(@Inject(WindowToken) private window,
                @Inject(UserStore) private userStore: UserStore,
                @Inject(HeaderService) private headerService: HeaderService,
                @Inject(HomeownerApi) private homeownerApi: HomeownerApi,
                @Inject(ContactApi) private contactApi: ContactApi,
                @Inject(SpinnerService) private spinnerService: SpinnerService,
                @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
                @Inject(CommonService) private commonService: CommonService,
                @Inject(Router) private router: Router) {

        if(this.router.getCurrentNavigation()) {
            this.$stateParams = this.router.getCurrentNavigation().extras.state;
        }
    }

    ngOnInit(): void {
        if(this.commonService.isGuest()) {
            // if isGuest, then hide, if not...
            this.headerService.setDisplayRightContent(false);
        }

        if (this.$stateParams?.pmcId) {
            this.showPmcInfo = true;
            this.getPMCDetails(this.$stateParams.pmcId).pipe(take(1)).subscribe();
        } else {
            let userId = this.userStore.getHoaHomeownerId();
            if (userId != null) {
                this.spinnerService.showSpinner();
                this.getFirstPMCDetails(userId)
                    .pipe(take(1)).subscribe({
                        next: () => {
                            this.spinnerService.closeSpinner();
                            this.showPmcInfo = true;
                        }, error: () => {
                            this.spinnerService.closeSpinner();
                            this.showPmcInfo = false;
                        }
                    });
            }
        }

    }

    openUrl(url) {
        this.window.open(url, '_blank');
    }

    getFirstPMCDetails(userId: number): Observable<void>{

        return new Observable<void>((observer) => {

            this.homeownerApi.homeownersIdPropertiesGet(userId)
                .pipe(take(1)).subscribe({
                    next: data => {
                        let properties = data;

                        if (properties.length > 0) {
                            let firstProperty = properties[0];
                            this.getPMCDetails(firstProperty.hoa.pmc.couponId)
                                .pipe(take(1)).subscribe({
                                    next: () => {
                                        observer.next()
                                    }, error: () => {
                                        observer.error(new Error())
                                    }
                                });
                        } else {
                            observer.error(new Error());
                        }
                    }, error: err => {
                        this.networkErrorService.handleNetworkError(err, true)
                            .pipe(take(1)).subscribe((_) => {
                                observer.error(new Error());
                            });
                    }
                });

        });
    }

    // Retrieve pmc details
    getPMCDetails(pmcCouponId: string): Observable<void>{

        return new Observable<void>((observer) => {
            this.contactApi.pmcOrganizationDetailsGET(true, pmcCouponId)
                .pipe(take(1)).subscribe({
                    next: resp => {
                        if (resp != null) {
                            this.pmc = resp;
                            this.displayPhoneNumber = this.getWorkPhone(this.pmc.contactInformation.phones);
                            this.displayUrl = this.getUrl(this.pmc.contactInformation.url);
                            this.displayUrl = this.displayUrl.replace("https://", "");
                            this.displayUrl = this.displayUrl.replace("http://", "");
                        } else {
                            observer.error(new Error());
                        }
                        observer.next();
                    },
                    error: err => {
                        this.networkErrorService.handleNetworkError(err, true)
                            .pipe(take(1)).subscribe((resp) => {
                                if (resp === true) {
                                    this.getPMCDetails(pmcCouponId).pipe(take(1)).subscribe();
                                }
                                observer.error(new Error());
                            });
                    }
                })
        });
    }

    getWorkPhone(phones: Phone[]) {
        for (let i = 0; i < phones.length; i++) {
            if (phones[i].type === "work") {
                return phones[i].value;
            }
        }
        return "";
    }

    getUrl(url: Url[]) {
        for (let i = 0; i < url.length; i++) {
            if (url[i].type === "main") {
                return url[i].value;
            }
        }
        return "";
    }
}

